import React from "react";
import { useSearch } from "../../../../contexts/SearchContext";
import {
  getAllDepartureDates,
  getAvailableMonthOfDeparture,
  getReturnDatesForDeparture,
  getFallbackLdsDatesForAllDestinations,
  resolveLdsSearchCityFromLocation,
} from "../../../../contexts/SearchContextHelpers";
import DatesInput from "../SubComponents/DatesInput/DatesInput";
import { Loader } from "../../../Loader/Loader";

/** Package tab dates cell — business logic only, no layout wrappers. */
export function PackageDatesFieldContent() {
  const {
    calendarDateArrival,
    setCalendarDateArrival,
    calendarDateLeave,
    setCalendarDateLeave,
    location,
    ldsDates,
    datesError,
    loadingDates,
    packageDateMode,
    setPackageDateMode,
    packageMonth,
    setPackageMonth,
  } = useSearch();
  const locationMeta = resolveLdsSearchCityFromLocation(location);
  const isAllDestinations = locationMeta.isAllDestinations;
  const parsedPkgMonthCount =
    Array.isArray(ldsDates) && ldsDates.length > 0
      ? getAvailableMonthOfDeparture(ldsDates).length
      : 0;
  const effectiveLdsDates =
    isAllDestinations &&
    (!Array.isArray(ldsDates) ||
      ldsDates.length === 0 ||
      parsedPkgMonthCount === 0)
      ? getFallbackLdsDatesForAllDestinations()
      : ldsDates;

  const hasChosenDestination =
    locationMeta.isAllDestinations ||
    Boolean(
      locationMeta.primary &&
        (String(locationMeta.primary.CITYCODE || "").trim() ||
          String(locationMeta.primary.AIRPORTCODE || "").trim()),
    );

  if (datesError) {
    return (
      <span className="search-engine-shell__control-placeholder">{datesError}</span>
    );
  }
  if (!hasChosenDestination && !effectiveLdsDates?.length) {
    return (
      <span className="search-engine-shell__control-placeholder">יש לבחור יעד</span>
    );
  }
  if (loadingDates && !isAllDestinations) {
    return (
      <span className="search-engine-shell__control-placeholder search-engine-shell__control-placeholder--relative">
        <Loader size="small" inline />
      </span>
    );
  }
  return (
    <DatesInput
      calendarDateArrival={calendarDateArrival}
      calendarDateLeave={calendarDateLeave}
      setCalendarDateArrival={setCalendarDateArrival}
      setCalendarDateLeave={setCalendarDateLeave}
      possibleArrivalDates={getAllDepartureDates(effectiveLdsDates)}
      possibleDepartureDates={getReturnDatesForDeparture(
        effectiveLdsDates,
        calendarDateArrival
      )}
      ldsDates={effectiveLdsDates}
      enableMonthMode
      dateMode={packageDateMode}
      onDateModeChange={setPackageDateMode}
      selectedMonth={packageMonth}
      onMonthSelect={setPackageMonth}
      availableMonths={getAvailableMonthOfDeparture(effectiveLdsDates)}
    />
  );
}
